import { Form } from '@arco-design/web-react';

import { SKU_RESOURCE_MODULES_FIELD } from './types';

const FormItem = Form.Item;

function HiddenFormCollector() {
  return null;
}

/** 注册 skuResourceModules hidden 字段，确保 setFieldValue / useWatch 可触发模块勾选 UI */
export function SkuResourceModulesRootField() {
  return (
    <FormItem field={SKU_RESOURCE_MODULES_FIELD} hidden style={{ display: 'none', margin: 0 }}>
      <HiddenFormCollector />
    </FormItem>
  );
}
